// extracted by css-extract-rspack-plugin
export default {"commitMessage":"ActivityCard-module__commitMessage__QJU6r"};